module.exports = __webpack_public_path__ + "img/wechatApp.f4109ab9.png";